import type { MappingFieldsResponse } from "@/types/fieldMappingConfig";

const MOCK_MAPPING_FIELDS: MappingFieldsResponse = {
  fields: [
    {
      name: "name",
      type: "string",
      unit: null,
      use_source_units: false,
      description: "The product's display name.",
    },
    {
      name: "description",
      type: "string",
      unit: null,
      use_source_units: false,
      description: "Long-form HTML or plain-text product description.",
    },
    {
      name: "short_description",
      type: "string",
      unit: null,
      use_source_units: false,
      description: "One-line marketing summary of the product.",
    },
    {
      name: "price",
      type: "number",
      unit: null,
      use_source_units: false,
      description: "List price of the product.",
    },
    {
      name: "image_url",
      type: "string",
      unit: null,
      use_source_units: false,
      description: "Primary product image URL.",
    },
    {
      name: "shipping_returns",
      type: "string",
      unit: null,
      use_source_units: false,
      description: "Shipping and returns policy text for the product.",
    },
    {
      name: "feature_highlight_text",
      type: "string",
      unit: null,
      use_source_units: false,
      description: "Short feature highlight or callout text shown on the PDP.",
    },
    {
      name: "product_video_url",
      type: "string",
      unit: null,
      use_source_units: false,
      description: "URL of the product demo or lifestyle video.",
    },
    {
      name: "related_skus",
      type: "string",
      unit: null,
      use_source_units: false,
      description: "Comma-separated list of related product SKUs.",
    },
    {
      name: "capacity",
      type: "number",
      unit: "oz",
      use_source_units: false,
      description: "Volume or capacity of the product (e.g. 32oz tumbler).",
    },
    {
      name: "boxed_length",
      type: "number",
      unit: "cm",
      use_source_units: true,
      description: "Packaged/shipping length of the product carton.",
    },
    {
      name: "boxed_width",
      type: "number",
      unit: null,
      use_source_units: true,
      description: "Packaged/shipping width of the product carton.",
    },
    {
      name: "boxed_height",
      type: "number",
      unit: null,
      use_source_units: true,
      description: "Packaged/shipping height of the product carton.",
    },
    {
      name: "boxed_weight",
      type: "number",
      unit: null,
      use_source_units: true,
      description: "Packaged/shipping weight of the product in its carton.",
    },
    {
      name: "opened_length",
      type: "number",
      unit: null,
      use_source_units: true,
      description: "Length of the product out of its packaging.",
    },
    {
      name: "opened_width",
      type: "number",
      unit: null,
      use_source_units: true,
      description: "Width of the product out of its packaging.",
    },
    {
      name: "opened_height",
      type: "number",
      unit: null,
      use_source_units: true,
      description: "Height of the product out of its packaging.",
    },
    {
      name: "opened_weight",
      type: "number",
      unit: null,
      use_source_units: true,
      description: "Weight of the product out of its packaging.",
    },
  ],
};

export function resolveMockMappingFields(): MappingFieldsResponse {
  return JSON.parse(
    JSON.stringify(MOCK_MAPPING_FIELDS),
  ) as MappingFieldsResponse;
}
